// TODO: Remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/esnext.symbol.metadata.js
// module id = 458
// module chunks = 0 1